

<div class="main-container">
  <div class="top-heading">
   <h2 id="email-heading">{{message}}</h2>
  <a href="https://hayrick.com/"
    ><img src = "../../../../../assets/logo-light.svg" height="60" width="300" alt="Hayrick logo"/></a>
  </div>
</div>
